<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/compare/shared/product-add-to-compare/product-add-to-compare.component.ts
-->
<ng-template #anchor></ng-template>
